import {combineReducers} from '@reduxjs/toolkit';

import areaCoverage from './area-coverage.js';
import basemapRules from './basemap-rules.js';
import compare from './compare.js';
import filters from './item-filters.js';
import focusedItems from './focused-items.js';
import folders from './folders.js';
import itemTypes from './item-types.js';
import labs from './labs.js';
import map from './map.js';
import mosaics from './mosaics.js';
import notifications from './notifications.js';
import orders from './orders.js';
import quickFocusedItems from './quick-focused-items.js';
import results from './results.js';
import search from './search.js';
import searchFilters from './search-filters.js';
import series from './series.js';
import settings from './settings.js';
import sidebar from './sidebar.js';
import subscriptions from './subscriptions.js';
import tiles from './tiles.js';
import tour from './tour.js';
import ui from './ui.js';
import {apiSlice} from '@explorer/api/apiSlice.js';

const combinedReducers = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  areaCoverage,
  basemapRules,
  compare,
  filters,
  focusedItems,
  folders,
  itemTypes,
  labs,
  map,
  mosaics,
  notifications,
  orders,
  quickFocusedItems,
  results,
  search,
  searchFilters,
  series,
  sidebar,
  subscriptions,
  tiles,
  tour,
  ui,
  settings,
});

export default combinedReducers;
